import './App.css';
import { IpifyProvider } from './contexts/IpifyContext';
import { ToastProvider } from './contexts/ToastContext';
import ContactFormPage from './pages/ContactFormPage';
import 'react-toastify/dist/ReactToastify.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import RedirectPage from './pages/RedirectPage';
import { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { UtmContextProvider } from 'marketing-tools';

const tagManagerArgsPos = {
  gtmId: 'GTM-5T72XPG',
};

const tagManagerArgsPlus = {
  gtmId: 'GTM-PRS9JM2',
};

const router = createBrowserRouter([
  {
    path: '/',
    element: <ContactFormPage />,
  },
  {
    path: '/redirect',
    element: <RedirectPage />,
  },
]);

function App() {
  useEffect(() => {
    const host = window.location.host;
    if (host.includes('pos')) {
      TagManager.initialize(tagManagerArgsPos);
    } else if (host.includes('plus')) {
      TagManager.initialize(tagManagerArgsPlus);
    }
  }, []);

  return (
    <UtmContextProvider otherParams={['source']}>
      <ToastProvider>
        <IpifyProvider>
          <RouterProvider router={router} />
        </IpifyProvider>
      </ToastProvider>
    </UtmContextProvider>
  );
}

export default App;
